import React from 'react';
import AttributeTable, { AttributeItem } from './AttributeTable';

import DescriptionContainerElement from './DescriptionContainerElement';
import './DescriptionContainer.scss';
import MediaBic from './MediaBic';
import MediaMidvox from './MediaMidvox';
import { ReviewDetails } from '../../components/Model/ReviewDetails';
import ReviewItem from './ReviewItem';

import DOMPurify from 'isomorphic-dompurify';
import { replaceAllComplex } from '../../../../../mol_function';

interface DescriptionContainerpProps {
  attribute: any;
  productsId: number;
  productsDescription: string;
  domainPrefix: string;
  category: string;
  reviews: ReviewDetails[];
  media: any;
  ean: string;
  title: string;
}

export default class DescriptionContainer extends React.Component<DescriptionContainerpProps> {
  render() {
    const descHeight = 156;
    let hideDesc = false;
    if (this.props.productsDescription.length == 0) hideDesc = true;

    let descHtml = this.props.productsDescription.replace(
      /(<? *script)/gi,
      'illegalscript',
    );

    if (DOMPurify != undefined && DOMPurify.sanitize != undefined) {
      const sanitizer = DOMPurify.sanitize;
      descHtml = sanitizer(descHtml);
    }

    return (
      <div className="DescriptionContainer">
        <DescriptionContainerElement
          description={replaceAllComplex(this.props.title, [
            { s: "\\'", r: "'" },
            { s: '\\"', r: '"' },
          ])}
          collapse={{
            collapseAction: (state) => {
              $('.wrapperAttribsOptions.extraDetails').toggleClass('show');
            },
            collapseText: 'alle Artikeldetails',
            expandText: 'Weniger Artikeldetails',
            collapseTitle:
              'Alle Artikeldetails ' +
              this.props.title +
              ' ' +
              this.props.category,
          }}
        >
          <AttributeTable
            data={this.props.attribute}
            details={false}
            productID={this.props.productsId}
            domainPrefix={this.props.domainPrefix}
            category={this.props.category}
            title={this.props.title}
          />
        </DescriptionContainerElement>
        {!hideDesc ? (
          <React.Fragment>
            <DescriptionContainerElement
              description="Produktbeschreibung"
              collapse={{
                collapseText: 'Weiterlesen',
                collapseTitle:
                  'Weiterlesen zu ' +
                  this.props.title +
                  ' ' +
                  this.props.category,
                expandText: 'Weniger',
                collapseAction: (state) => {
                  let newHeight = 0;

                  if (state) {
                    let winX = window.scrollX;
                    let winY = window.scrollY;
                    setTimeout(() => {
                      window.scrollTo(winX, winY);
                    }, 100);
                    $('#productDescriptionContainer').removeClass('collapse');
                    $('.readMore').hide();
                    ReviewItem;
                    newHeight = 10000;
                  } else {
                    $('#productDescriptionContainer').addClass('collapse');

                    $('.readMore').show();
                    newHeight = descHeight;
                  }
                  $('#productDescriptionContainer').css(
                    'max-height',
                    newHeight + 'px',
                  );
                },
              }}
            >
              <div
                id="productDescriptionContainer"
                className="collapse"
                style={{ maxHeight: descHeight + 'px' }}
              >
                <div
                  id="productDescription"
                  className="productGeneral collapse"
                  style={{ textAlign: 'justify' }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: descHtml,
                    }}
                  ></div>
                </div>
              </div>
            </DescriptionContainerElement>
          </React.Fragment>
        ) : null}
        {this.props.reviews.length > 0 ? (
          <React.Fragment>
            <DescriptionContainerElement description="Bewertungen">
              {this.props.reviews.map((item, index) => {
                return (
                  <ReviewItem
                    item={item}
                    domainPrefix={this.props.domainPrefix}
                    productsId={this.props.productsId}
                    key={'Review_' + index}
                  ></ReviewItem>
                );
              })}
            </DescriptionContainerElement>
          </React.Fragment>
        ) : null}
        {this.props.media != undefined &&
        Object.keys(this.props.media).length > 0 ? (
          <React.Fragment>
            {this.props.media.bic ? (
              <DescriptionContainerElement description="leseprobe" key={'bic'}>
                <MediaBic
                  media={this.props.media}
                  ean={this.props.ean}
                ></MediaBic>
              </DescriptionContainerElement>
            ) : null}
            {this.props.media.midvox_leseprobe ? (
              <DescriptionContainerElement
                description="leseprobe"
                key={'midvox'}
              >
                <MediaMidvox
                  media={this.props.media}
                  ean={this.props.ean}
                ></MediaMidvox>
              </DescriptionContainerElement>
            ) : null}
          </React.Fragment>
        ) : null}
        {/*
        <DescriptionContainerElement description="Lesenprube">
         
        <Media media={this.body.media} ean={this.body.ean}></Media>  
         
        
        </DescriptionContainerElement>
         

        <div
          className="DescriptionContainerElement"
          style={{ backgroundColor: "red", minHeight: "50px" }}
        ></div>
        <div
          className="DescriptionContainerElement"
          style={{ minHeight: "100px", backgroundColor: "brown" }}
        ></div>*/}
      </div>
    );
  }
}
